module.exports = __webpack_public_path__ + "static/media/home-fill.9a3b1743.svg";